/** Google OAuth가 차단되는 인앱 브라우저(WebView) 감지 */

export function getInAppBrowserName(): string | null {
  if (typeof window === "undefined") return null;
  const ua = navigator.userAgent || "";

  if (/KAKAOTALK/i.test(ua)) return "카카오톡";
  if (/Instagram/i.test(ua)) return "인스타그램";
  if (/FBAN|FBAV/i.test(ua)) return "페이스북";
  if (/Line\//i.test(ua)) return "LINE";
  if (/NAVER\(inapp|NAVER/i.test(ua) && /NAVER/i.test(ua)) return "네이버 앱";
  if (/MicroMessenger/i.test(ua)) return "WeChat";
  if (/DaumApps/i.test(ua)) return "다음 앱";

  if (/Android/i.test(ua) && /;\s*wv\)/i.test(ua)) return "앱 내 브라우저";
  if (/iPhone|iPad|iPod/i.test(ua) && !/Safari/i.test(ua)) return "앱 내 브라우저";

  return null;
}

/** Google 로그인 OAuth가 WebView 정책으로 차단되는 환경 */
export function blocksGoogleOAuth(): boolean {
  return getInAppBrowserName() !== null;
}

export function getGoogleOAuthBlockedMessage(browserName?: string | null): string {
  const name = browserName ?? getInAppBrowserName() ?? "앱 내 브라우저";
  return `${name}에서는 구글 보안 정책상 구글 로그인을 사용할 수 없습니다. Safari 또는 Chrome에서 열어주세요.`;
}

/** Android: Chrome intent, iOS: 클립보드 복사 */
export async function openCurrentPageInExternalBrowser(
  url = typeof window !== "undefined" ? window.location.href : ""
): Promise<"intent" | "copy" | "failed"> {
  if (!url || typeof window === "undefined") return "failed";

  const ua = navigator.userAgent || "";

  if (/Android/i.test(ua)) {
    const path = url.replace(/^https?:\/\//, "");
    window.location.href = `intent://${path}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(url)};end`;
    return "intent";
  }

  try {
    await navigator.clipboard.writeText(url);
    return "copy";
  } catch {
    return "failed";
  }
}

export function getExternalBrowserHelpSteps(browserName?: string | null): string[] {
  const name = browserName ?? getInAppBrowserName();
  if (name === "카카오톡") {
    return [
      "우측 상단 ⋯ 메뉴 → 「Safari에서 열기」 또는 「Chrome에서 열기」",
      "또는 아래 「브라우저에서 열기」 버튼을 눌러 주세요",
    ];
  }
  return [
    "우측 상단 메뉴에서 「Safari」 또는 「Chrome」으로 열기",
    "또는 아래 「브라우저에서 열기」 버튼을 눌러 주세요",
  ];
}
